import * as React from 'react'
import { Box } from '@mui/material'
import KpiResults from '@/components/DatePickers/KpiResults'
import DateRangeFilterCard from '@/components/common/DateRangeFilterCard'
import { getDefaultRange } from '@/utils/consumerReadingsDateRanges'

export type DateRange = { from: Date | null; to: Date | null }

type KPI = {
  label: string
  value: string | number
  sublabel?: string
}

type Props = {
  range?: DateRange
  onRangeChange?: (r: DateRange) => void
  onSearch?: (r: DateRange) => void
  kpis?: KPI[]
  disabled?: boolean
  loading?: boolean
}

export default function DetailedFilter({
  range: rangeProp,
  onRangeChange,
  onSearch,
  disabled,
  loading,
}: Props) {
  const getDefaultRangeForFilter = (): DateRange => getDefaultRange(0, 7)
  const [innerRange, setInnerRange] =
    React.useState<DateRange>(getDefaultRangeForFilter())
  // @ts-ignore
  const [previousInnerRange, setPreviousInnerRange] =
    React.useState<DateRange>(getDefaultRange())
  const [results, setResults] = React.useState<{
    total: number
    hourlyAvg: number
  } | null>(null)

  const isControlled = rangeProp !== undefined
  const currRange: DateRange = isControlled
    ? (rangeProp as DateRange)
    : innerRange

  const applyRange = React.useCallback(
    (next: DateRange) => {
      onRangeChange?.(next)
      if (!isControlled) {
        setPreviousInnerRange(innerRange)
        setInnerRange(next)
      }
    },
    [onRangeChange, isControlled]
  )

  const { from, to } = currRange

  const handleSearch = () => {
    if (currRange.from && currRange.to && currRange.from > currRange.to) return
    if (onSearch) {
      onSearch(currRange)
      return
    }

    // Demo fake results
    const hours =
      from && to
        ? Math.max(1, Math.round((to.getTime() - from.getTime()) / 36e5))
        : 24
    const total = Number((Math.random() * 500 + 100).toFixed(3))
    const hourlyAvg = Number((total / hours).toFixed(3))
    setResults({ total, hourlyAvg })
  }

  return (
    <Box
      dir="rtl"
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, ml: '10px' }}
    >
      <DateRangeFilterCard
        range={currRange}
        onRangeChange={applyRange}
        onSearch={() => handleSearch()}
        loading={loading}
        disabled={disabled}
        compact
      />

      {results && (
        <KpiResults totalM3={results.total} hourlyAvgM3={results.hourlyAvg} />
      )}
    </Box>
  )
}
